import { axiosSwagger } from "@/axios";
import Vue from 'vue';


export const state = {
}


export const getters = {
}


export const mutations = {
    // eslint-disable-next-line no-unused-vars
    updateProfile: (state, user) => {
        let userData = Vue.prototype.$getUser();

        userData.firstName = user?.firstName;
        userData.middleName = user?.middleName;
        userData.lastName = user?.lastName;

        userData.position = user?.position;
        userData.email = user?.email;

        localStorage.setItem("USER", JSON.stringify(userData));
    },
    // eslint-disable-next-line no-unused-vars
    updateEmailProfile: (state, email) => {
        let userData = Vue.prototype.$getUser();

        userData.email = email;

        localStorage.setItem("USER", JSON.stringify(userData));
    }
}


export const actions = {
    async updateProfile({ commit }, user) {
        return await axiosSwagger
            .put(`/api/Account/Update/${user.id}`, user)
            .then((response) => {
                commit("updateProfile", user);

                return response;
            });
    },
    // eslint-disable-next-line no-unused-vars
    async changePassword({ commit }, password) {
        return await axiosSwagger
            .post("/api/Account/Password/Change", password)
            .then((response) => {
                return response;
            });
    },
    // eslint-disable-next-line no-unused-vars
    async changeEmail({ commit }, data) {
        return await axiosSwagger
            .put("/api/Account/Email", data)
            .then((response) => {
                commit("updateEmailProfile", data.email);

                return response;
            });
    },
    // eslint-disable-next-line no-unused-vars
    async changeUsername({ commit }, data) {
        return await axiosSwagger
            .put("/api/Account/UserName", data)
            .then((response) => {
                return response;
            });
    },
}
